import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { SchoolCalendar } from './school-calendar.model';
import { SchoolCalendarService } from './school-calendar.service';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class SchoolCalendarPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private schoolCalendarService: SchoolCalendarService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.schoolCalendarService.find(id).subscribe(schoolCalendar => {
                if (schoolCalendar.begining) {
                    schoolCalendar.begining = {
                        year: schoolCalendar.begining.getFullYear(),
                        month: schoolCalendar.begining.getMonth() + 1,
                        day: schoolCalendar.begining.getDate()
                    };
                }
                if (schoolCalendar.ending) {
                    schoolCalendar.ending = {
                        year: schoolCalendar.ending.getFullYear(),
                        month: schoolCalendar.ending.getMonth() + 1,
                        day: schoolCalendar.ending.getDate()
                    };
                }
                this.schoolCalendarModalRef(component, schoolCalendar);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else {
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.schoolCalendarModalRef(component, new SchoolCalendar());
            });
        }
    }

    schoolCalendarModalRef(component: Component, schoolCalendar: SchoolCalendar): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.schoolCalendar = schoolCalendar;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar-popup.service.ts